import React from "react";
import {
  Grid,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import * as d3 from "d3";
import OpportunitiesTable from "./OpportunitiesTable";
import JudgementSection from "./JudgementSection";
import ForecastSummaryTable from "./ForecastSummaryTable";
import ForecastByRepTable from "./ForecastByRepTable";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(2),
  },
  paper: {
    width: "100%",
    padding: theme.spacing(3),
    boxSizing: "border-box",
    margin: "0 auto",
  },
  repName: {
    fontWeight: 600,
    color: "#333",
    marginBottom: theme.spacing(1),
  },
  weekEnding: {
    color: "#666",
    marginBottom: theme.spacing(2),
  },
  title:{
    // marginBottom: '1rem',
    fontWeight: 600
  },
  summaryTable: {
    marginTop: theme.spacing(2),
    width: "auto", // ✅ shrink to fit content
    display: "inline-block",
  },
  tableCell: {
    padding: "5px 8px", // ✅ fixed comma issue
    border: "none",
  },
  categoryLabel: {
    fontWeight: 600,
    fontSize: "1rem",
  },
  categoryValue: {
    fontWeight: 600,
    fontSize: "1.1rem",
  },
  opportunitiesSection: {
    marginTop: theme.spacing(4),
  },
  section: {
    width: "20%",
    marginTop: theme.spacing(3),
  },
}));

const ForecastRollupHeader = ({
  repName,
  weekEnding,
  repTotals,
  managerTotals,
  currencySymbol,
  includeForForecastRollup,
  opportunities,
  columns,
  valueLabel,
  onForecastCategoryChange,
  forecastCategories,
  judgementValues,
  judgementRepValues,
  onJudgementChange,
  isManager,
  onManagerOverrideChange,
  team,
  role,
  wonData,
  quotaData,
  teamQuota,
  currentFiscalQuarter,
  repsSummary
}) => {
  const classes = useStyles();

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";

    // 🔹 Handle both "YYYY-MM-DD" and full ISO strings by ignoring time part
    const pureDateString = dateString.split("T")[0]; // e.g. "2025-10-10"

    // 🔹 Create date without timezone shift
    const [year, month, day] = pureDateString.split("-").map(Number);
    const date = new Date(year, month - 1, day); // JS month is 0-based

    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const getRepCategoryTotal = (categoryName) => repTotals?.[categoryName] || 0;
  const getManagerCategoryTotal = (categoryName) =>
    managerTotals?.[categoryName] || 0;

  return (
    <Grid container className={classes.root}>
      <Paper elevation={3} className={classes.paper}>
        {/* Header Info */}
        <Typography variant="h5" className={classes.repName}>
          {isManager ? "Team" : "Rep"}:{" "}
          {isManager ? team : repName || "SkyGeni Admin"}
        </Typography>
        <Typography variant="subtitle1" className={classes.weekEnding}>
           {currentFiscalQuarter} Forecast Rollup for week ending: {formatDate(weekEnding)}
        </Typography>

        {/* Summary Tables Side by Side */}
        {includeForForecastRollup?.length > 0 && (
          <Grid
            container
            spacing={2}
            alignItems="flex-start"
            style={{ padding: 0, width: "auto" }}
          >
            {/* Rep Forecast Roll Up Table */}
            {/* <Grid item style={{ padding: 0, width: "auto", flex: "none" }}>
              <TableContainer className={classes.summaryTable}>
                <Table size="small">
                  <TableBody>
                    <TableRow>
                      <TableCell
                        colSpan={2}
                        className={`${classes.tableCell} ${classes.categoryLabel}`}
                      >
                        Rep Forecast Roll Up
                      </TableCell>
                    </TableRow>
                    {includeForForecastRollup.map((category, index) => (
                      <TableRow key={index}>
                        <TableCell
                          className={`${classes.tableCell} ${classes.categoryLabel}`}
                        >
                          {category}:
                        </TableCell>
                        <TableCell
                          className={`${classes.tableCell} ${classes.categoryValue}`}
                          align="right"
                          data-test={`rep-${category
                            .toLowerCase()
                            .replace(/\s+/g, "-")}-total`}
                        >
                          {currencySymbol}
                          {d3.format(",")(
                            Math.round(getRepCategoryTotal(category))
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid> */}
            {
                !isManager && 
                   <Grid item xs={5}>
                     <Typography variant="h2" className={classes.title} align="center">
          Rep Forecast Roll Up
        </Typography>
                <ForecastSummaryTable forecastData={[]}  judgementValues={judgementValues}    onJudgementChange={onJudgementChange}
            includeForForecastRollup={includeForForecastRollup} currencySymbol={currencySymbol}
            repTotals={repTotals} 
            wonData={wonData}
            quotaData={quotaData}
             isEdit={true}
            />
                </Grid>
            }

            {/* Manager Forecast Roll Up Table */}
            {isManager && (

                <>
                {/* Rep Forecast Roll Up Table */}
            {/* <Grid item style={{ padding: 0, width: "auto", flex: "none" }}>
              <TableContainer className={classes.summaryTable}>
                <Table size="small">
                  <TableBody>
                    <TableRow>
                      <TableCell
                        colSpan={2}
                        className={`${classes.tableCell} ${classes.categoryLabel}`}
                      >
                        Rep Forecast Roll Up
                      </TableCell>
                    </TableRow>
                    {includeForForecastRollup.map((category, index) => (
                      <TableRow key={index}>
                        <TableCell
                          className={`${classes.tableCell} ${classes.categoryLabel}`}
                        >
                          {category}:
                        </TableCell>
                        <TableCell
                          className={`${classes.tableCell} ${classes.categoryValue}`}
                          align="right"
                          data-test={`rep-${category
                            .toLowerCase()
                            .replace(/\s+/g, "-")}-total`}
                        >
                          {currencySymbol}
                          {d3.format(",")(
                            Math.round(getRepCategoryTotal(category))
                          )}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid> */}

             {/* <Grid item style={{ padding: 0, width: "auto", flex: "none" }}>
                <TableContainer className={classes.summaryTable}>
                  <Table size="small">
                    <TableBody>
                      <TableRow>
                        <TableCell
                          colSpan={2}
                          className={`${classes.tableCell} ${classes.categoryLabel}`}
                        >
                          Manager Forecast Roll Up
                        </TableCell>
                      </TableRow>
                      {includeForForecastRollup.map((category, index) => (
                        <TableRow key={index}>
                          <TableCell
                            className={`${classes.tableCell} ${classes.categoryLabel}`}
                          >
                            {category}:
                          </TableCell>
                          <TableCell
                            className={`${classes.tableCell} ${classes.categoryValue}`}
                            align="right"
                            data-test={`manager-${category
                              .toLowerCase()
                              .replace(/\s+/g, "-")}-total`}
                          >
                            {currencySymbol}
                            {d3.format(",")(
                              Math.round(getManagerCategoryTotal(category))
                            )}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid> */}

               <Grid item xs={5}>
                     <Typography variant="h2" className={classes.title} align="center">
          Manager Forecast Roll Up
        </Typography>
                <ForecastSummaryTable forecastData={[]}  judgementValues={judgementValues}    onJudgementChange={onJudgementChange}
            includeForForecastRollup={includeForForecastRollup} currencySymbol={currencySymbol}
            repTotals={managerTotals} 
            wonData={wonData}
            quotaData={teamQuota}
             isEdit={true}
             quotaLabel={'Team Quota'}
            />
                </Grid>

                  <Grid item xs={1}></Grid>

               <Grid item xs={5}>
                     <Typography variant="h2" className={classes.title} align="center">
          Rep Forecast Roll Up
        </Typography>
                <ForecastSummaryTable forecastData={[]}  judgementValues={judgementRepValues}    onJudgementChange={onJudgementChange}
            includeForForecastRollup={includeForForecastRollup} currencySymbol={currencySymbol}
            repTotals={repTotals} 
            wonData={wonData}
            quotaData={quotaData}
            isEdit={false}
            quotaLabel={'Sum of Rep Quotas'}
            />
                </Grid>

                 <Grid item xs={10} style={{marginTop: '1rem'}}>
                     <Typography variant="h2" className={classes.title} align="center" style={{fontSize: '1.2rem'}}>
          Summary by Rep
        </Typography>
                <ForecastByRepTable data={repsSummary}
            />
                </Grid>
                </>
             
            )}
          </Grid>
        )}

        {/* Opportunities Table */}
        <div className={classes.opportunitiesSection} style={{marginTop: '4rem'}}>
          <OpportunitiesTable
            opportunities={opportunities}
            columns={columns}
            currencySymbol={currencySymbol}
            valueLabel={valueLabel}
            onForecastCategoryChange={onForecastCategoryChange}
            forecastCategories={forecastCategories}
            isManager={isManager}
            onManagerOverrideChange={onManagerOverrideChange}
          />
        </div>

        {/* Judgement Section */}
     
      </Paper>
    </Grid>
  );
};

export default ForecastRollupHeader;
